module.exports = __webpack_public_path__ + "img/SKMJ_saferoad2.441594ce.jpg";